import { ICON } from '@/src/general/enums/icons'
import { useTranslate } from '@/src/lang/useTranslate'

import { MESSAGE_TYPE } from '../../../models/Message.enums'
import type { TChatMessageProps } from './ChatMessage.types'
import { ChatMessageAuto } from './ChatMessageAuto'
import { ChatMessageDeleted } from './ChatMessageDeleted'
import { ChatMessageReply } from './ChatMessageReply'
import { ChatMessageSimple } from './ChatMessageSimple'

export const ChatMessage = ({
  contactName,
  createdAt,
  deletedAt,
  firstOfBatch,
  isSender,
  lastOfBatch,
  payload,
  onDeleteMessage,
  onReportMessage,
  showWarning,
  type,
}: TChatMessageProps) => {
  const { t } = useTranslate()

  if (deletedAt) {
    return <ChatMessageDeleted isSender={isSender} firstOfBatch={firstOfBatch} lastOfBatch={lastOfBatch} />
  }

  switch (type) {
    case MESSAGE_TYPE.TEXT:
      return (
        <ChatMessageSimple
          text={payload.text}
          createdAt={createdAt}
          firstOfBatch={firstOfBatch}
          isSender={isSender}
          lastOfBatch={lastOfBatch}
          onDeleteMessage={onDeleteMessage}
          onReportMessage={onReportMessage}
          showWarning={showWarning}
        />
      )
    case MESSAGE_TYPE.REPLY_TO_UPLIFT_MESSAGE:
      return (
        <ChatMessageReply
          text={payload.text}
          repliedMessage={{
            text: payload.uplift_text,
            header: {
              icon: ICON.INTENTION,
              title: isSender ? t('message.from', { contactName }) : t('words.your-message'),
            },
            thumbnail: {
              icon: ICON.INTENTION,
              title: isSender ? t('words.your-intention') : t('intention.from', { contactName }),
              message: payload.intention_text,
            },
          }}
          createdAt={createdAt}
          firstOfBatch={firstOfBatch}
          isSender={isSender}
          lastOfBatch={lastOfBatch}
          onDeleteMessage={onDeleteMessage}
          onReportMessage={onReportMessage}
          showWarning={showWarning}
        />
      )
    case MESSAGE_TYPE.PRAYER_ON_COMMENT:
      return (
        <ChatMessageAuto
          isSender={isSender}
          createdAt={createdAt}
          firstOfBatch={firstOfBatch}
          lastOfBatch={lastOfBatch}
          type={type}
          contactName={contactName}
          thumbnail={
            'commentContent' in payload
              ? {
                  icon: ICON.COMMENT,
                  title: isSender ? t('comment.from', { contactName }) : t('comment.write.your-comment'),
                  message: payload.commentContent,
                }
              : undefined
          }
        />
      )
    case MESSAGE_TYPE.THANKS_INTENTION_PRAYER:
      return (
        <ChatMessageAuto
          isSender={isSender}
          createdAt={createdAt}
          firstOfBatch={firstOfBatch}
          lastOfBatch={lastOfBatch}
          type={type}
          contactName={contactName}
          thumbnail={{
            icon: ICON.INTENTION,
            title: isSender ? t('words.your-intention') : t('intention.from', { contactName }),
            message: payload.intention?.content,
          }}
        />
      )
    case MESSAGE_TYPE.PRAYER:
    case MESSAGE_TYPE.GODSON_JOINED:
    case MESSAGE_TYPE.THANKS_BIRTHDAY_INTENTION_PRAYER:
    case MESSAGE_TYPE.THANKS_ARRIVAL_INTENTION_PRAYER:
      return (
        <ChatMessageAuto
          isSender={isSender}
          createdAt={createdAt}
          firstOfBatch={firstOfBatch}
          lastOfBatch={lastOfBatch}
          type={type}
          contactName={contactName}
        />
      )
    default:
      return null
  }
}
